export interface IDemographicsContact {
  lastName: string;
  firstName: string;
  middleName: string;
  relationship: string;
  emergency: string;
  phone: string;
}

export interface IDemographicsRecord {
  patientId: string;

  fullName: string;
  dateOfBirth: string;
  timeOfBirth: string;
  sex: string;
  race: string;
  ethnicityCode: string;
  language: string;
  maritalStatus: string;
  patientNumber: string;
  socialSecurityNumber: string;
  preferredName: string;
  formerName: string;
  nickname: string;
  birthStateCode: string;
  birthCountryCode: string;
  bloodType: string;

  referringProvider: string;
  referringProviderPhone: string;
  pcpProvider: string;
  pcpProviderPhone: string;
  usualCaregiver: string;
  usualCaregiverPhone: string;
  privacyStatus: string;

  homeAddress: string;
  homeCityStateZip: string;
  homeCounty: string;
  homeCrossStreet: string;
  homePhone: string;
  homeCarPhone: string;
  homeFax: string;
  homePager: string;
  homeEmail: string;
  homeStartDate: string;
  homeEndDate: string;

  officeAddress: string;
  officeCityStateZip: string;
  officeCounty: string;
  officeCrossStreet: string;
  officePhone: string;
  officeCarPhone: string;
  officeFax: string;
  officePager: string;
  officeEmail: string;
  officeStartDate: string;
  officeEndDate: string;

  employer: string;
  employerStatus: string;
  occupation: string;
  industry: string;

  guarantorFullName: string;
  guarantorRelationship: string;
  guarantorSex: string;
  guarantorDateOfBirth: string;
  guarantorSSN: string;

  guarantorHomeAddress: string;
  guarantorHomeCityStateZip: string;
  guarantorHomeCounty: string;
  guarantorHomeCrossStreet: string;
  guarantorHomePhone: string;
  guarantorHomeCarPhone: string;
  guarantorHomeFax: string;
  guarantorHomePager: string;
  guarantorHomeEmail: string;
  guarantorHomeStartDate: string;
  guarantorHomeEndDate: string;

  guarantorOfficeAddress: string;
  guarantorOfficeCityStateZip: string;
  guarantorOfficeCounty: string;
  guarantorOfficeCrossStreet: string;
  guarantorOfficePhone: string;
  guarantorOfficeCarPhone: string;
  guarantorOfficeFax: string;
  guarantorOfficePager: string;
  guarantorOfficeEmail: string;
  guarantorOfficeStartDate: string;
  guarantorOfficeEndDate: string;

  pharmacyName: string;
  pharmacyAddress: string;
  pharmacyCityStateZip: string;
  pharmacyCounty: string;
  pharmacyCrossStreet: string;
  pharmacyPhone: string;
  pharmacyCarPhone: string;
  pharmacyFax: string;
  pharmacyPager: string;
  pharmacyEmail: string;

  status: string;
  patientType: string;
  medicAlert: string;
  organDonor: string;
  vipIndicator: string;

  chartId: string;
  accountId: string;
  releaseOfInfo: string;
  hcfaSignature: string;
  notifyMethod: string;
  ui?: {
    downloadLinks?: {
      csv?: string;
      pdf?: string;
      xls?: string;
    };
  };

  contacts: IDemographicsContact[];
}

export const getDemographics = (store: {
  demographics: { data: IDemographicsRecord | null };
}) => store.demographics.data;
